import { notificationActions } from "../../actionTypes";

const initialState = {
	notifications: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case notificationActions.UPDATE_MULTIPLE_NOTIFICATIONS: {
			return { ...state, ...initialState };
		}

		case notificationActions.UPDATE_MULTIPLE_NOTIFICATIONS_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				notifications: action.payload,
			};
		}

		case notificationActions.UPDATE_MULTIPLE_NOTIFICATIONS_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
